<template>
  <v-container>
    <v-row class="mb-6">
      <header-title :title="title" />
    </v-row>

    <v-row v-for="index in 3" v-bind:key="index">
      <v-col>
        <v-row align="center">
          <div class="body-1 font-weight-medium primaryText--text">Reference {{ index }}</div>
        </v-row>
        <v-row align="center">
          <v-col v-if="!referenceFileExists(index)" xs="10" sm="10" md="4">
            <v-file-input
              accept="application/pdf, application/msword"
              prepend-icon="mdi-file-upload-outline"
              :loading="uploadingFile"
              label="Reference Document"
              placeholder="Upload reference"
              single-line
              :error-messages="referenceFileErrors(`reference${index}FileId`)"
              @change="onFileChanged($event,referenceFileRefName(index),`reference${index}`)"
            />
          </v-col>
          <v-col v-else>
            <v-text-field
              clear-icon="mdi-trash-can-outline"
              append-outer-icon="mdi-open-in-new"
              @click:append-outer="onFileOpen(`reference${index}`)"
              label="Reference Document"
              :value="referenceOriginalFileName(index)"
              @click:clear="onFileCleared(referenceFileRefName(index),`reference${index}`)"
              readonly
              clearable
            />
          </v-col>
          <v-col xs="10" sm="10" md="4">
            <v-text-field
              v-model="profile[`reference${index}ProvidedBy`]"
              label="Reference Provider"
              placeholder="Name of the provider of this reference"
              :loading="updateText"
              :error-messages="referenceProvidedByErrors(referenceProviderRefName(index))"
              @change="onTextChange(referenceProviderRefName(index),$event)"
            />
          </v-col>
          <v-col xs="10" sm="10" md="4">
            <v-text-field
              v-model="profile[`reference${index}Position`]"
              label="Position"
              placeholder="Position"
              :loading="updateText"
              :error-messages="referencePositionErrors(referencePositionRefName(index))"              
              @change="onTextChange(referencePositionRefName(index),$event)"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import HeaderTitle from "../components/HeaderTitle";
import { mapFields } from "vuex-map-fields";
import submissionMixin from "../mixins/submission.mixin";
import { required } from "vuelidate/lib/validators";

export default {
  name: "ReferenceLetters",
  components: {
    HeaderTitle
  },
  data() {
    return {
      title:
        "Please upload THREE reference letters from industry,\nacademia and/or civil servant representatives."
    };
  },
  mixins: [submissionMixin],
  computed: {
    ...mapFields("profile", [
      "profile",
      "profile.reference1FileId",
      "profile.reference1ProvidedBy",
      "profile.reference1Position",
      "profile.reference1",
      "profile.reference2FileId",
      "profile.reference2ProvidedBy",
      "profile.reference2Position",
      "profile.reference2",
      "profile.reference3FileId",
      "profile.reference3ProvidedBy",
      "profile.reference3Position",
      "profile.reference3"
    ])
  },
  validations: {
    reference1FileId: { required },
    reference1ProvidedBy: { required },
    reference1Position: { required },
    reference2FileId: { required },
    reference2ProvidedBy: { required },
    reference2Position: { required },    
    reference3FileId: { required },
    reference3ProvidedBy: { required },
    reference3Position: { required }  
  },
  methods: {
    referenceFileExists(index) {
      const referenceFieldName = this.referenceFileRefName(index);
      return this[referenceFieldName] && this[referenceFieldName].length;
    },

    referenceFileRefName(index) {
      return `reference${index}FileId`;
    },
    referenceProviderRefName(index) {
      return `reference${index}ProvidedBy`;
    },
    referencePositionRefName(index) {
      return `reference${index}Position`;
    },
    referenceOriginalFileName(index) {
      return this[`reference${index}`].originalName;
    },

    referenceFileErrors(fieldName){
      const errors = [];
      if (!this.$v[fieldName].$dirty) return errors;
      !this.$v[fieldName].required &&
        errors.push("Reference file is required");
      return errors;      
    },
    referenceProvidedByErrors(fieldName){
      const errors = [];
      if (!this.$v[fieldName].$dirty) return errors;
      !this.$v[fieldName].required &&
        errors.push("This field is required");
      return errors;   
    },    
    referencePositionErrors(fieldName){
      const errors = [];
      if (!this.$v[fieldName].$dirty) return errors;
      !this.$v[fieldName].required &&
        errors.push("This field is required");
      return errors;  
    },

    validateForm() {
      // perform form validation
      this.$v.$touch();

      // return validation result (true/false)
      return !this.$v.$invalid;      
    }    
  }
};
</script>